import React, {useRef} from "react"
import {UseStores} from "../../hooks/UseStores"
import {observer} from "mobx-react-lite"
import "./index.scss"
import {OutsideClick} from "../../hooks/OutsideClick"

const TermsAndConditionsModal = () => {
  const {modalStore} = UseStores()
  const modalRef = useRef(null)
  OutsideClick(modalRef, () => {
    modalStore.setIsOpen(false)
  })
  return (
    modalStore.isOpen && (
      <div className="modal-container">
        <div className="modal">
          <div ref={modalRef} className="modal-main">
            <div className="modal-header">
              <div>TERMS OF USE </div>
              <div
                className="close-button"
                onClick={() => {
                  modalStore.setIsOpen(false)
                }}
              ></div>
            </div>
            <div className="modal-body modal-padding">
              <p>
                THE TERMS AND CONDITIONS SET FORTH BELOW (THE "TERMS") GOVERN YOUR USE OF
                THE GROUNDTRUTH LOCATION SOFTWARE SITE ON THE WORLD WIDE WEB.{" "}
              </p>
            </div>
            <div className="modal-footer"></div>
            <div className="close-btn" onClick={() => modalStore.setIsOpen(false)}>
              {" "}
              Close
            </div>
          </div>
        </div>
      </div>
    )
  )
}
export default observer(TermsAndConditionsModal)
